import { pushVirtualPageView as pushGtmVirtualPageView } from "@/core/lib/gtm/gtm";
import { pushVirtualPageView as pushHotjarVirtualPageView } from "@/core/lib/hotjar/hotjar";
import { pushVirtualPageView as pushDataDogVirtualPageView } from "@/core/lib/datadog/datadog";
import { pushCamundaFirstStepViewVariable } from "@/core/lib/camunda/camunda";
import {
  pushAmplitudeCCStarted,
  pushVirtualPageView as pushAmplitudeVirtualPageView,
} from "@/core/lib/amplitude/amplitude";
import getEventToExposeCallback, {
  EventCallback,
} from "@/core/utils/eventsToExpose/getEventToExposeCallback";
import { pushCCStartedLynxWebhook } from "@/core/lib/lynx/lynx";

type TrackPageViewEventsData = {
  stepTitle: string;
  definitionName?: string;
  domain?: string;
  processId?: string;
  eventsToExpose?: string[];
  sendAmplitudeEvent?: boolean;
};

function trackPageViewEvents({
  stepTitle,
  definitionName,
  domain,
  processId,
  eventsToExpose,
  sendAmplitudeEvent = true,
}: TrackPageViewEventsData) {
  pushGtmVirtualPageView(stepTitle, definitionName);
  pushHotjarVirtualPageView(stepTitle);
  pushDataDogVirtualPageView(stepTitle, definitionName, domain ?? "");
  pushCamundaFirstStepViewVariable(stepTitle, processId ?? "");
  if (sendAmplitudeEvent) {
    pushAmplitudeVirtualPageView(stepTitle);
  }
  if (eventsToExpose)
    exposeTrackingEvents(eventsToExpose, definitionName, domain ?? "");
}

function exposeTrackingEvents(
  eventsToExpose: string[],
  definitionName: string | undefined,
  domain: string
) {
  eventsToExpose.forEach((event: string) => {
    const exposeEventCallback: EventCallback | undefined =
      getEventToExposeCallback(event);
    if (exposeEventCallback) exposeEventCallback({ definitionName, domain });
  });
}
export function trackCCStartedEvent(flightProblem: string | undefined) {
  pushAmplitudeCCStarted(flightProblem);
}
export function pushCCStartedWebhook(flightProblem: string | undefined) {
  pushCCStartedLynxWebhook(flightProblem);
}

export default trackPageViewEvents;
